import { PackageCoverOptions, SelectedCoverImage } from '@/services/content/package/types'
import TravelImage from '@/assets/package-covers/travel.svg'
import BusinessImage from '@/assets/package-covers/business.svg'
import HomeImage from '@/assets/package-covers/home.svg'
import LawImage from '@/assets/package-covers/law.svg'
import ComputersImage from '@/assets/package-covers/computers.svg'
import CultureImage from '@/assets/package-covers/culture.svg'
import NavigationImage from '@/assets/package-covers/navigation.svg'
import HealthImage from '@/assets/package-covers/health.svg'
import ShoppingImage from '@/assets/package-covers/shopping.svg'
import RelationshipsImage from '@/assets/package-covers/relationships.svg'
import DefaultImage from '@/assets/package-covers/default.svg'

export const defaultPackageCoverOptionsMap: Record<Exclude<PackageCoverOptions, PackageCoverOptions.Uploaded | PackageCoverOptions.Default>, string> = {
  [PackageCoverOptions.Travel]: TravelImage,
  [PackageCoverOptions.Business]: BusinessImage,
  [PackageCoverOptions.Home]: HomeImage,
  [PackageCoverOptions.Law]: LawImage,
  [PackageCoverOptions.Computers]: ComputersImage,
  [PackageCoverOptions.Culture]: CultureImage,
  [PackageCoverOptions.Navigation]: NavigationImage,
  [PackageCoverOptions.Health]: HealthImage,
  [PackageCoverOptions.Shopping]: ShoppingImage,
  [PackageCoverOptions.Relationships]: RelationshipsImage
}

export function getCoverImage(coverImage: string): string {
  if (!coverImage) {
    return DefaultImage
  }

  const matched = Object.entries(defaultPackageCoverOptionsMap).find(([key]) => key.toLowerCase() === coverImage.toLowerCase())

  return matched?.[1] || coverImage
}

export function extractCoverImagePath(url: string): string | null {
  const match = url?.match(/(packages\/[^?#]+)/)
  return match ? match[1] : null
}

export function resolveSelectedCoverImage(coverImage: string): SelectedCoverImage | null {
  if (!coverImage) return null

  const matched = Object.entries(defaultPackageCoverOptionsMap).find(([key]) => key.toLowerCase() === coverImage.toLowerCase())

  if (matched) {
    return {
      type: matched[0] as PackageCoverOptions,
      image: matched[1]
    }
  }

  return {
    type: PackageCoverOptions.Uploaded,
    image: coverImage
  }
}

export function onCoverImageError(event: Event) {
  (event.target as HTMLImageElement).src = DefaultImage
}
